import React from 'react';
import styled from 'styled-components';
import CartItem from '../../../domain/entities/Cart/CartItem';
import { CartPrice } from './CommonStyles';
import { IGetPriceOptions } from '../../../controllers/OrderSummaryViewController/OrderSummaryViewController';

interface ICartItemMonogramPrice {
  item: CartItem;
  getPrice(price: number, options?: IGetPriceOptions): string;
  engravingLabel: string;
  freeLabel: string;
  showFreeLabelAsPrice: boolean;
}

const CartItemPricesContainer = styled.div`
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.47px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const CartItemEngravingContainer = styled(CartItemPricesContainer)`
  margin-top: 8px;
`;

const InitialPrice = styled.span`
  text-decoration: line-through;
`;

const CartItemMonogramLabel = styled(CartPrice)`
`;

const CartItemMonogramPrice = ({
  item,
  getPrice,
  engravingLabel,
  freeLabel,
  showFreeLabelAsPrice,
}: ICartItemMonogramPrice): JSX.Element => (
  <CartItemEngravingContainer>
    <CartItemMonogramLabel className="acac-cart-item-monogram-label">
      {engravingLabel}
    </CartItemMonogramLabel>
    {item.isMonogramDiscounted && (
      <InitialPrice>{getPrice(item.monogramUnitPrice)}</InitialPrice>
    )}
    <CartPrice className="acac-cart-item-monogram-price">
      {getPrice(item.engravingPrice, { freeLabel, showFreeLabelAsPrice })}
    </CartPrice>
  </CartItemEngravingContainer>
);

export default CartItemMonogramPrice;
